import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

import * as z from "zod";
import type { FormSubmitEvent } from "#ui/types";

import { useVerifyStore } from "~/stores/verify";

type Schema = z.output<typeof schema>;


export default /*@__PURE__*/_defineComponent({
  __name: 'ForgotPasswordForm',
  emits: ["otp-sent", "back-to-login", "error"],
  setup(__props, { emit: __emit }) {

const verify = useVerifyStore();

const emit = __emit;

const errorMessage = ref<string>();
const loading = ref(false);
// Watch for changes on errorMessage
watch(errorMessage, (newValue) => {
  if (newValue) {
    setTimeout(() => {
      errorMessage.value = undefined;
    }, 2000);
  }
});

const fields = [
  {
    name: "email",
    type: "text" as const,
    label: "Email",
    placeholder: "Enter your email",
    required: true,
  },
];

const schema = z.object({
  email: z.string().email("Invalid email"),
});

async function onSubmit(payload: FormSubmitEvent<Schema>) {
  try {
    loading.value = true;
    const data = await verify.forgotPassword(payload.data.email);
    loading.value = false;
    emit("otp-sent", payload.data.email);
  } catch (error) {
    errorMessage.value = "Failed to send reset password email. Please try again.";
    emit("error", errorMessage.value);
    console.error("Error:", error);
  } finally {
    loading.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_UButton = _resolveComponent("UButton")!
  const _component_UAlert = _resolveComponent("UAlert")!
  const _component_NuxtLink = _resolveComponent("NuxtLink")!
  const _component_UAuthForm = _resolveComponent("UAuthForm")!

  return (_openBlock(), _createBlock(_component_UAuthForm, {
    loading: _unref(loading),
    fields: fields,
    schema: _unref(schema),
    title: "Reset your password",
    align: "top",
    icon: "i-solar:password-outline",
    class: "bg-transparent",
    ui: { root: 'space-y-6', footer: 'text-sm text-gray-500 dark:text-gray-400' },
    onSubmit: onSubmit
  }, {
    description: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-sm text-gray-500 dark:text-gray-400" }, " If you have forgotten your password, enter your email to receive a link to reset it. ", -1)),
      _createVNode(_component_UButton, {
        variant: "link",
        color: "purple",
        class: "font-medium text-purple-600 hover:text-purple-500 dark:text-purple-400",
        label: "Back to login",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('back-to-login')))
      })
    ]),
    validation: _withCtx(() => [
      (_unref(errorMessage))
        ? (_openBlock(), _createBlock(_component_UAlert, {
            key: 0,
            color: "red",
            variant: "soft",
            icon: "i-heroicons-exclamation-triangle-20-solid",
            title: "Error",
            description: _unref(errorMessage),
            class: "mb-4"
          }, null, 8, ["description"]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _cache[4] || (_cache[4] = _createTextVNode(" By signing in, you agree to our ", -1)),
      _createVNode(_component_NuxtLink, {
        to: "/terms",
        class: "font-medium text-gray-900 dark:text-white underline"
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode("Terms of Service", -1)
        ]))]),
        _: 1
      }),
      _cache[5] || (_cache[5] = _createTextVNode(" and ", -1)),
      _createVNode(_component_NuxtLink, {
        to: "/privacy-policy",
        class: "font-medium text-gray-900 dark:text-white underline"
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode("Privacy Policy", -1)
        ]))]),
        _: 1
      }),
      _cache[6] || (_cache[6] = _createTextVNode(". ", -1))
    ]),
    _: 1
  }, 8, ["loading", "schema"]))
}
}

})